import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'sign-in' },

    // Redirect signed-in user to the '/home'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'home' },

    // Auth routes for guests
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes') },
            { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
            { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes') },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') }
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
            { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes') }
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: 'home', loadComponent: () => import('app/modules/dashboard/dashboard.component').then(m => m.DashboardComponent) },
            { path: 'vendors-documents', loadComponent: () => import('app/modules/vendors-documents/vendors-documents.component').then(m => m.VendorsDocumentsComponent) },
            { path: 'data-table', loadComponent: () => import('app/modules/data-table/data-table.component').then(m => m.DataTableComponent) },
            { path: 'coupons', loadComponent: () => import('app/modules/coupon/coupon.component').then(m => m.CouponComponent) },
            { path: 'task-master', loadComponent: () => import('app/modules/task-master/task-master.component').then(m => m.TaskMasterComponent), data: { isService: false } },
            { path: 'service-master', loadComponent: () => import('app/modules/task-master/task-master.component').then(m => m.TaskMasterComponent), data: { isService: true } },
            { path: 'vendor-service-mapping', loadComponent: () => import('app/modules/vendor-service-mapping/vendor-service-mapping.component').then(m => m.VendorServiceMappingComponent) },
            { path: 'workforce', loadComponent: () => import('app/modules/workforce-mgnt/workforce-mgnt.component').then(m => m.WorkforceMgntComponent) },
            { path: 'workforce-blocklist', loadComponent: () => import('app/modules/workforce-blocklist/workforce-blocklist.component').then(m => m.WorkforceBlocklistComponent) },
            { path: 'blast-confirmation', loadComponent: () => import('app/modules/blast-confirmation/blast-confirmation.component').then(m => m.BlastConfirmationComponent) },
            { path: 'commission', loadComponent: () => import('app/modules/commission/commission.component').then(m => m.AdminCommissionComponent) },
            { path: 'payout-management', loadComponent: () => import('app/modules/payout/payout.component').then(m => m.PayoutComponent) },
            { path: 'ad-management', loadComponent: () => import('app/modules/ad-mgnt/ad-mgnt.component').then(m => m.AdMgntComponent) },
            { path: 'app-config', loadComponent: () => import('app/modules/app-config/app-config.component').then(m => m.AppConfigComponent) }
        ]
    }


];
